export const formLoginNamesConvertor = (itemName) => {
  // eslint-disable-next-line default-case
  switch (itemName) {
    case "firstName":
      return "First name";
    case "secondName":
      return "Second name";
    case "email":
      return "Email";
    case "password":
      return "Password";
    case "passwordConformation":
      return "Password conformation";
  }
};


export const formSpotNamesConvertor = (itemName) => {
  // eslint-disable-next-line default-case
  switch (itemName) {
    case "countries":
      return "Countries";
    case "organizationFields":
      return "Organization fields";
    case "hotSpotFields":
      return "Fields";
    case "greenSpotFields":
      return "Fields"
    case "businessFields":
      return "Business fields";
    case "category":
      return "Category";
    case "type":
      return "Type";
    case "fields":
      return "Fields";

  }
};
export default formLoginNamesConvertor;



